import React from 'react';
import { concatStrings } from '../utilities';
const DfbQuote = (props) => {
  return (
    <figure className={concatStrings('dfb-Quote', props.add_class)}>
      <blockquote className="dfb-Quote-blockquote">
        {props.text}
      </blockquote>
      {props.quote_author &&
        <figcaption className="dfb-Quote-author">
          <span className="dfb-Quote-authorName">
            {props.quote_author}
          </span>
          {props.quote_author_position &&
            <span className="dfb-Quote-authorPosition">
              {props.quote_author_position}
            </span>
          }
        </figcaption>
      }
    </figure>
  );
}
export default DfbQuote;

